"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityMapImage = exports.EntityMapImageDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_type_image_1 = require("./entity-type-image");
var types_1 = require("../../types");
exports.EntityMapImageDefaultProps = {
  style: 'outdoors',
  zoom: 7,
  width: 400,
  height: 225
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      width: ", "px;\n      height: ", "px;\n      flex-shrink: 0;\n    "], ["\n      width: ", "px;\n      height: ", "px;\n      flex-shrink: 0;\n    "])), props._width, props._height);
  })
});
var TypeImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    max-width: 100%;\n    height: 100%;\n    object-fit: cover;\n  "], ["\n    max-width: 100%;\n    height: 100%;\n    object-fit: cover;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  TypeImage: (0, styled_components_1.default)(entity_type_image_1.EntityTypeImage)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), TypeImageStyles),
  Image: styled_components_1.default.img(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles)
};
var EntityMapImage = function (props) {
  var className = props.className,
    entity = props.entity,
    zoom = props.zoom,
    width = props.width,
    height = props.height,
    style = props.style;
  var latitude = entity.latitude,
    longitude = entity.longitude;
  var key = types_1.MAPBOX_STYLE_KEYS[style];
  var apiKey = process.env.MAPBOX_API_KEY;
  if (!apiKey) {
    console.warn("EntityMapImage: Cannot render static map as no Mapbox API Key is available.");
  }
  var canRender = key && latitude && longitude && apiKey;
  var url = "https://api.mapbox.com/styles/v1/mapbox/".concat(key, "/static/").concat(longitude, ",").concat(latitude, ",").concat(zoom, ",0,60/").concat(width, "x").concat(height, "@2x?access_token=").concat(apiKey);
  return react_1.default.createElement(My.Container, {
    _width: width,
    _height: height,
    className: className
  }, canRender ? react_1.default.createElement(My.Image, {
    src: url
  }) : react_1.default.createElement(My.TypeImage, {
    entityTypeName: entity.__typename
  }));
};
exports.EntityMapImage = EntityMapImage;
exports.EntityMapImage.defaultProps = exports.EntityMapImageDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;